"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UNKNOWN_ERROR_MESSAGE = exports.TABLE_SELECTOR_TEXT = exports.TABLE_SELECTOR_BUTTON = exports.INTRODUCTION_TITLE = exports.INTRODUCTION_TEXT = exports.INTRODUCTION_HEADER = exports.DISABLED_MESSAGE = exports.CONFIRMATION_BUTTON = exports.CHECKOUT_TEXT = exports.CHECKOUT_PLACEHOLDER = exports.CHECKOUT_LABEL = void 0;
var INTRODUCTION_TEXT = "Your table number can be found on your table.<br />Having trouble? Reach out to your server!";
exports.INTRODUCTION_TEXT = INTRODUCTION_TEXT;
var INTRODUCTION_HEADER = "Welcome to {restaurant}!";
exports.INTRODUCTION_HEADER = INTRODUCTION_HEADER;
var INTRODUCTION_TITLE = "Enter a Table Number to Order";
exports.INTRODUCTION_TITLE = INTRODUCTION_TITLE;
var CONFIRMATION_BUTTON = "Confirm My Table Number";
exports.CONFIRMATION_BUTTON = CONFIRMATION_BUTTON;
var TABLE_SELECTOR_TEXT = "My Table Number";
exports.TABLE_SELECTOR_TEXT = TABLE_SELECTOR_TEXT;
var TABLE_SELECTOR_BUTTON = "Edit your table number";
exports.TABLE_SELECTOR_BUTTON = TABLE_SELECTOR_BUTTON;
var CHECKOUT_TEXT = "Your Table Number";
exports.CHECKOUT_TEXT = CHECKOUT_TEXT;
var CHECKOUT_PLACEHOLDER = "Enter Your Table Number";
exports.CHECKOUT_PLACEHOLDER = CHECKOUT_PLACEHOLDER;
var CHECKOUT_LABEL = "Table #:";
exports.CHECKOUT_LABEL = CHECKOUT_LABEL;
var DISABLED_MESSAGE = "Table ordering is currently unavailable. Please contact your server to order.";
exports.DISABLED_MESSAGE = DISABLED_MESSAGE;
var UNKNOWN_ERROR_MESSAGE = "An unknown error occurred. Please try again or contact the restaurant for help.";
exports.UNKNOWN_ERROR_MESSAGE = UNKNOWN_ERROR_MESSAGE;
var _default = {
  CHECKOUT_LABEL: CHECKOUT_LABEL,
  CHECKOUT_PLACEHOLDER: CHECKOUT_PLACEHOLDER,
  CHECKOUT_TEXT: CHECKOUT_TEXT,
  CONFIRMATION_BUTTON: CONFIRMATION_BUTTON,
  DISABLED_MESSAGE: DISABLED_MESSAGE,
  INTRODUCTION_HEADER: INTRODUCTION_HEADER,
  INTRODUCTION_TEXT: INTRODUCTION_TEXT,
  INTRODUCTION_TITLE: INTRODUCTION_TITLE,
  TABLE_SELECTOR_BUTTON: TABLE_SELECTOR_BUTTON,
  TABLE_SELECTOR_TEXT: TABLE_SELECTOR_TEXT,
  UNKNOWN_ERROR_MESSAGE: UNKNOWN_ERROR_MESSAGE
};
exports["default"] = _default;